import { Observation } from './observation'
import { ProductType } from './productType'

export const NN_ANNOTATION_SOURCE = 'NN' as const
export const GT_ANNOTATION_SOURCE = 'GT' as const

export type AnnotationSource =
  | typeof NN_ANNOTATION_SOURCE
  | typeof GT_ANNOTATION_SOURCE

export const TAG_ANNOTATION_TYPE = 'Tag' as const
export const BRUSH_ANNOTATION_TYPE = 'Brush' as const
export const POLYLINE_ANNOTATION_TYPE = 'Polyline' as const

export type TagAnnotationType = typeof TAG_ANNOTATION_TYPE
export type BrushAnnotationType = typeof BRUSH_ANNOTATION_TYPE
export type PolylineAnnotationType = typeof POLYLINE_ANNOTATION_TYPE

export type AnnotationType =
  | TagAnnotationType
  | BrushAnnotationType
  | PolylineAnnotationType

export type AnnotationData = Record<string, unknown> // intentionally left unknown, we shouldn't be aware of Label Studio internal representation

export interface Annotation {
  id: number
  annotationSource: AnnotationSource
  annotationType: AnnotationType
  observation: Observation
  data: AnnotationData
  creationDate: Date
  promotedFrom?: Annotation
}

export const getAnnotationTypeBy = (productType: ProductType): AnnotationType =>
  ({
    classification: TAG_ANNOTATION_TYPE,
    anomaly: TAG_ANNOTATION_TYPE,
    segmentation: BRUSH_ANNOTATION_TYPE,
    classification_patch: BRUSH_ANNOTATION_TYPE,
  }[productType])
